import styled from 'styled-components'

export const Container = styled.div`
    width: 330px;
    height: 430px;
`

export const Heading = styled.div`
    position: absolute;
    width: 230px;
    height: 30.06px;
    left: 56px;
    top: 16px;

    font-family: Avenir;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 32px;

    color: #555555;
`

export const HeadingBorder = styled.div`
    position: absolute;
    width: 330px;
    height: 0px;
    left: 0px;
    top: 64px;

    border: 0.5px solid rgba(0, 0, 0, 0.12);
`

export const QRCodeInstruction = styled.div`
    position: absolute;
    width: 118px;
    height: 20px;
    left: 115px;
    top: 85px;

    font-family: Avenir;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;

    color: #555555;
`

export const QRCodeContainer = styled.div`
    position: absolute;
    width: 200px;
    height: 200px;
    left: 65px;
    top: 120px;
`

export const Instruction = styled.div`
    position: absolute;
    left: 15px;
    width: 300px;
    top: 355px;
    text-align: center;
    font-family: Avenir;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
`

export const LeftLine = styled.div`
    position: absolute;
    width: 130px;
    height: 0px;
    left: 20px;
    top: 335px;
    border: 0.5px solid rgba(0, 0, 0, 0.12);
`

export const RightLine = styled.div`
    position: absolute;
    width: 130px;
    height: 0px;
    left: 180px;
    top: 335px;
    border: 0.5px solid rgba(0, 0, 0, 0.12);
`

export const Text = styled.div`
    position: absolute;
    top: 325px;
    left: 155px;
    font-family: Avenir;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.5);
`
